module.exports = "<p>\n  flagged-products-table works!\n</p>\n"